import { Outlet } from 'react-router-dom';
import GoSupportDashboardPage from './GoSupportDashboardPage';

const GoSupportPage = () => {
  return (
    <>
      <GoSupportDashboardPage />
      <Outlet />
    </>
  );
};

export default GoSupportPage;
